<template>
  <div class="wrapper flex column" v-if="showTag">
    <div class="header flex0 flex color_fff">
      <v-icon-arrow-left class="flex0" @click.native="close"></v-icon-arrow-left>
      <div class="flex1 ellipsis">{{ file.name }}</div>
    </div>
    <div class="flex1 scan-box flex flex-center flex-center-2 overflow-y-auto">
      <img :src="src" alt="" v-if="fileType==='image'"/>
      <video :src="src" controls controlsList="nodownload" v-else @canplay="onCanplay"></video>
    </div>
    <div class="flex0 pt10 pb10 pr15 pl15 footer flex">
      <van-button type="info" size="small" round @click="send">发 送</van-button>
    </div>
  </div>
</template>

<script>
import VIconArrowLeft from "@/plugins/v-icon-arrow-left";
import readfile from "@/utils/readfile";

export default {
  name: "upload-scan",
  components: {VIconArrowLeft},
  data() {
    return {
      duration: 0,
      showTag: false,
      files: null,
      curr: 0,
      type: '',
      src: ''
    }
  },
  computed: {
    file() {
      if (this.files)
        return this.files[this.curr]
      return null
    },
    fileType() {
      let type = this.file.type;
      let name = this.file.name;
      if (type.includes('video')) {
        return 'video';
      }
      return 'image';
    }
  },
  methods: {
    onCanplay(e) {
      Log('e', e);
      const el = e.target || {}
      this.duration = el.duration
    },

    open() {
      this.showTag = true;
      this.type = '';
      this.init();
    },
    close() {
      this.showTag = false;
      if (this.remove) {
        this.remove(this.type);
      }
    },
    init() {
      this.$nextTick(async () => {
        Log('file,type', this.file);
        if (this.file) {
          this.src = await readfile(this.file);
        } else {
          this.init();
        }
      })
    },

    send() {
      if (this.duration >= 61) return bus.$emit('msg', '时长不能超过60s');
      this.type = 'confirm'
      this.close()
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../common/public";

.wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background-color: #000000;
}

.header {
  @include h_lh(45px);

  > font {
    width: px2rem(45px);
    text-align: center;
  }
}

.scan-box {
  img, video {
    max-height: 100%;
    max-width: 100%;
  }
}

.footer {
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/plugins/dialog/upload-scan.vue